import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function HotArticles() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              热门推荐
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">大家都在看的内容</p>
          </div>
          <Link
            to="/category/tech"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {hotArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer ${
                idx === 0 ? "md:col-span-2" : ""
              }`}
            >
              <div className={`flex-shrink-0 ${idx === 0 ? "w-full md:w-72" : "w-full sm:w-44"} h-48 sm:h-auto overflow-hidden rounded-lg`}>
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col justify-center flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                    {article.categoryName}
                  </span>
                  {idx === 0 && (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium">
                      爆款
                    </span>
                  )}
                </div>
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-line"></i> {article.likes.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i> {article.comments}
                  </span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}